import { render, staticRenderFns } from "./TicketConnected.vue?vue&type=template&id=24b8d590&scoped=true&"
import script from "./TicketConnected.vue?vue&type=script&lang=js&"
export * from "./TicketConnected.vue?vue&type=script&lang=js&"
import style0 from "./TicketConnected.vue?vue&type=style&index=0&id=24b8d590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8d590",
  null
  
)

export default component.exports